(function () {

  function initRegistrationForm() {

    const steps = [
      document.getElementById("step1"),
      document.getElementById("step2"),
      document.getElementById("step3"),
      document.getElementById("step4")
    ];

    const indicators = [
      document.getElementById("step1-indicator"),
      document.getElementById("step2-indicator"),
      document.getElementById("step3-indicator"),
      document.getElementById("step4-indicator")
    ];

    const progressBar = document.getElementById("dd-progress-bar");
    const progressText = document.getElementById("dd-time");
    const progressPercent = document.getElementById("dd-percent");

    if (!steps[0]) {
      return;
    }

    let currentStep = 0;


    function updateProgress() {

      const percent = Math.round(
        ((currentStep + 1) / steps.length) * 100
      );

      if (progressBar) {
        progressBar.style.width = percent + "%";
      }

      if (progressPercent) {
        progressPercent.textContent = percent + "%";
      }

      if (progressText) {

        if (percent === 25) {
          progressText.textContent = "⏱ About 1 minute remaining";
        } else if (percent < 100) {
          progressText.textContent = "◉ Almost there...";
        } else {
          progressText.textContent = "✓ Ready to complete";
        }

      }
    }


    function showStep(stepNumber) {

      if (stepNumber < 0 || stepNumber >= steps.length) {
        return;
      }

      steps.forEach(function (step, index) {

        if (!step) {
          return;
        }

        if (index === stepNumber) {

          step.classList.add("active");

        } else {

          step.classList.remove("active");

        }

      });


      indicators.forEach(function (indicator, index) {

        if (!indicator) {
          return;
        }

        if (index === stepNumber) {

          indicator.classList.add("active");

        } else {

          indicator.classList.remove("active");

        }

      });


      currentStep = stepNumber;

      updateProgress();

    }


    /* NEXT BUTTONS */
  

document.querySelectorAll(".dd-next").forEach(function (button) {
  button.addEventListener("click", function (event) {
    event.preventDefault();

    const currentStepElement = steps[currentStep];

    if (currentStepElement) {
      const requiredFields = currentStepElement.querySelectorAll(
        "input[required], textarea[required], select[required]"
      );

      let allValid = true;

      requiredFields.forEach(function (field) {
        if (!field.value.trim()) {
          field.reportValidity();
          allValid = false;
        }
      });

      if (!allValid) {
        return;
      }
    }

   if (button.id === "submit-registration") {

  const informationConsent = document.getElementById("consent_information");
  const emergencyConsent = document.getElementById("consent_emergency");

  if (!informationConsent.checked || !emergencyConsent.checked) {
    alert("Please confirm all required permissions before completing the registration.");
    return;
  }

  const fields = document.querySelectorAll(
  'input:not([type="button"]):not([type="submit"]), select, textarea'
);

let registrationDetails = "";

fields.forEach(function(field) {
  if (field.name || field.id) {
    if (
      (field.type === "checkbox" || field.type === "radio") &&
      !field.checked
    ) {
      return;
    }

    const label = document.querySelector(
      'label[for="' + field.id + '"]'
    );

    const fieldName = label
      ? label.innerText.trim()
      : (field.name || field.id);

    registrationDetails +=
      fieldName + ": " + field.value + "\n";
  }
});

/* SEND REGISTRATION TO GOOGLE SHEETS */

const googleSheetURL = "https://script.google.com/macros/s/AKfycbzWgGrb-9VTFaYZsW5V4d8av9SqT4GfxI6pJcIHL77B0oEDdeuhsUInMllPyN7RNl8Tig/exec";

function getFieldValue(id) {
  const field = document.getElementById(id);
  return field ? field.value.trim() : "";
}

/* GET THE CHILD'S NAME */

const childFirstName = getFieldValue("child_first_name");
const childLastName = getFieldValue("child_last_name");

const childName =
  (childFirstName + " " + childLastName).trim();

/* CALCULATE CHILD'S AGE FROM DATE OF BIRTH */

const dob = getFieldValue("child_dob");

let childAge = "";

if (dob) {
  const birthDate = new Date(dob);
  const today = new Date();

  childAge = today.getFullYear() - birthDate.getFullYear();

  const monthDifference =
    today.getMonth() - birthDate.getMonth();

  if (
    monthDifference < 0 ||
    (monthDifference === 0 &&
      today.getDate() < birthDate.getDate())
  ) {
    childAge--;
  }
}

/* GET SESSION */

const sessionField = document.querySelector(
  'select[id*="session" i], select[name*="session" i], input[id*="session" i], input[name*="session" i]'
);

const session = sessionField
  ? sessionField.value.trim()
  : "";

/* DATA FOR GOOGLE SHEET */

const consentField = document.getElementById("consent_information");

const videoPhotoConsent =
  consentField && consentField.checked ? "Yes" : "No";

const sheetData = {
  parentName: getFieldValue("parent_name"),
  parentEmail: getFieldValue("parent_email"),
  parentPhone: getFieldValue("parent_phone"),
  orderNumber: getFieldValue("order_number"),
  childName: childName,
  childAge: childAge,
  session: session,
  venue: new URLSearchParams(window.location.search).get("venue") || "",
  medicalAllergy: getFieldValue("medical_info"),
  videoPhotoConsent: videoPhotoConsent
};

fetch(googleSheetURL, {
  method: "POST",
  mode: "no-cors",
  headers: {
    "Content-Type": "text/plain;charset=utf-8"
  },
  body: JSON.stringify(sheetData)
});

  const parentEmailField = document.querySelector(
    "input[type='email'], input[name*='email' i]"
  );

  const parentEmail = parentEmailField ? parentEmailField.value.trim() : "";

  if (!parentEmail) {
    alert("Please enter your email address before submitting the registration.");
    return;
  }

  const formData = new FormData();

  formData.append("form_type", "contact");
  formData.append("utf8", "✓");
  formData.append("contact[email]", parentEmail);
  formData.append(
    "contact[subject]",
    "Dream Dodgeball® Child Registration"
  );
  formData.append(
    "contact[body]",
    "NEW DREAM DODGEBALL® CHILD REGISTRATION\n\n" + registrationDetails
  );

  fetch("/contact", {
    method: "POST",
    body: formData
  })
  .then(function() {
    alert("🎉 Booking Confirmed!\n\nYour child's registration is now complete. Thank you for booking with Dream Dodgeball®!\n\nPlease close this page or window. If you keep it open, please refresh the page to view your booking confirmation.");
  })
  .catch(function(error) {
    console.error("Registration submission error:", error);
    alert("There was a problem sending the registration. Please try again.");
  });

  return;
}

    showStep(currentStep + 1);
  });
});

    /* BACK BUTTONS */

    document.querySelectorAll(".dd-back").forEach(function (button) {

      button.addEventListener("click", function (event) {

        event.preventDefault();

        showStep(currentStep - 1);

      });

    });


    /* AUTO-FILL FROM URL */

    const params = new URLSearchParams(window.location.search);

    const parentName =
      params.get("parent_name") || params.get("name");

    const parentEmail =
      params.get("parent_email") || params.get("email");

    const parentPhone =
      params.get("parent_phone");

    const orderNumber =
      params.get("order_number") || params.get("order");


    if (parentName) {

      const field = document.getElementById("parent_name");

      if (field) {
        field.value = parentName;
        field.readOnly = true;
      }

    }


    if (parentEmail) {

      const field = document.getElementById("parent_email");

      if (field) {
        field.value = parentEmail;
        field.readOnly = true;
      }

    }


    if (parentPhone) {

      const field = document.getElementById("parent_phone");

      if (field) {
        field.value = parentPhone;
        field.readOnly = true;
      }

    }


    if (orderNumber) {

      const field = document.getElementById("order_number");

      if (field) {
        field.value = orderNumber;
        field.readOnly = true;
      }

    }


    /* START */

    showStep(0);

  }


  /* Works on normal page load */

  if (document.readyState === "loading") {

    document.addEventListener(
      "DOMContentLoaded",
      initRegistrationForm
    );

  } else {

    initRegistrationForm();

  }


})();

